import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, umsUrl, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { SUPPORT_FILTER, SUPPORT_FILTER_SUCCESS, SUPPORT_FILTER_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* SupportFilter({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/admin/support-ticket-filters`,
      method: 'GET',
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: SUPPORT_FILTER_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: SUPPORT_FILTER_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: SUPPORT_FILTER_ERROR, payload: error });
  }
}

export function* watchSupportFilter() {
  yield takeEvery(SUPPORT_FILTER, SupportFilter);
}

function* SupportFilterSaga() {
  yield all([fork(watchSupportFilter)]);
}

export default SupportFilterSaga;
